import { gsap, ScrollTrigger, SplitText } from "./gsapSetup";

/**
 * Usage:
 * <p class="gs-fill-text" data-from="#A3A3A3" data-to="#111111">Some text</p>
 */
export function initScrollFillText(selector = ".gs-fill-text") {
  const els = gsap.utils.toArray(selector);
  if (!els.length) return;

  // respect reduced motion
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  const splits = [];

  els.forEach((el) => {
    const from = el.dataset.from || "#e8e8e8"; // gray
    const to = el.dataset.to || "#111111";     // black

    // Split into chars
    const split = new SplitText(el, { type: "chars" });
    splits.push(split);

    // Set initial color
    gsap.set(split.chars, { color: from });

    // Scroll-driven fill
    gsap.to(split.chars, {
      color: to,
      stagger: { each: 0.02, from: "start" },
      ease: "none", // scrub feels best with none (the scroll is the easing)
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        end: "bottom 30%",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  });

  // Return cleanup (handy for SPA)
  return () => {
    splits.forEach((s) => s.revert());
    ScrollTrigger.getAll().forEach((t) => t.kill());
  };
}

/**
 * Optional: prevent any triggers from working until your loader finishes.
 * Call this once on boot.
 *
 * Your loader should do:
 * window.dispatchEvent(new Event("loader:done"));
 */
export function gateScrollAnimationsUntilLoaderDone() {
  // If you use a class like <html class="is-loading">, keep triggers disabled until removed
  ScrollTrigger.disable(false);

  const enable = () => {
    ScrollTrigger.enable(false);
    ScrollTrigger.refresh(true);
    window.removeEventListener("loader:done", enable);
  };

  window.addEventListener("loader:done", enable, { once: true });
}
